import { DisclosureGroup } from "react-aria-components";

export default function Accordion({
  children,
  className,
}: {
  readonly children: React.ReactNode;
  readonly className?: string;
}) {
  return (
    <DisclosureGroup className={className} defaultExpandedKeys={[]}>
      {children}
    </DisclosureGroup>
  );
}
